document.addEventListener('DOMContentLoaded', function() {
  const videoCarousel = document.querySelector('[data-js-video-carousel]');
  
  if (!videoCarousel) return;
  
  const swiperContainer = videoCarousel.querySelector('.video-carousel-swiper');
  const videos = videoCarousel.querySelectorAll('video[data-video-index]');
  const volumeControls = videoCarousel.querySelectorAll('.video-carousel__volume-control');
  
           // Verificar se o Swiper está disponível
         if (typeof Swiper === 'undefined') {
           setTimeout(() => {
             initializeVideoCarousel();
           }, 2000);
           return;
         }
  
  // Aguardar um pouco mais para garantir que tudo esteja carregado
  setTimeout(() => {
    initializeVideoCarousel();
  }, 500);
  
           function initializeVideoCarousel() {
           try {
             // Verificar se todos os elementos necessários existem
             if (!swiperContainer || !videos.length) {
      return;
    }
    
                   // Inicializar Swiper com slides centralizados
             const swiper = new Swiper(swiperContainer, {
         slidesPerView: 1.6,
         centeredSlides: true,
               centereBounds: true,
         loop: true,
               spaceBetween: 10,
               effect: 'slide',
               speed: 600,
               watchSlidesProgress: true,
               slideActiveClass: 'swiper-slide-active',
               allowTouchMove: true,
               slideToClickedSlide: true,
        
        // Navegação
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        
        // Paginação
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
        },
        
        // Breakpoints responsivos
        breakpoints: {
          320: {
            slidesPerView: 1.6,
            spaceBetween: 10,
          },
          1024: {
            slidesPerView: 3.4,
            spaceBetween: 10,
          },
          1200: {
            slidesPerView: 5,
            spaceBetween: 10,
          }
        },
        
                 // Eventos
        on: {
           init: function() {
             handleSlideChangeTransitionEnd(this);
          },
           slideChangeTransitionEnd: function() {
             handleSlideChangeTransitionEnd(this);
          }
        }
      });
      

      
                   // Função para lidar com o fim da transição do slide
             function handleSlideChangeTransitionEnd(swiperInstance) {
               if (!swiperInstance || typeof swiperInstance.realIndex === 'undefined') {
      return;
    }
    
               const realIndex = swiperInstance.realIndex;

               // Pausar todos os vídeos exceto o ativo
               videos.forEach((video, index) => {
                 if (index !== realIndex && !video.paused) {
        video.pause();
                 }
               });

               // Aplicar altura aos slides
               swiperInstance.slides.forEach((slide, index) => {
                 const video = slide.querySelector('video');
                 
                 if (index === swiperInstance.activeIndex) {
                   // Slide ativo - 20% mais alto
                   const currentHeight = slide.offsetHeight;
                   const newHeight = currentHeight * 1.2;
                   slide.style.height = newHeight + 'px';
                   slide.style.zIndex = '2';
                   if (video) {
                     video.style.objectFit = 'cover';
                     video.style.height = '100%';
                   }
    } else {
                   // Slides inativos - voltar à altura original
                   slide.style.height = '';
                   slide.style.zIndex = '1';
                   if (video) {
                     video.style.objectFit = 'cover';
                     video.style.height = '100%';
                   }
                 }
               });

                                // Encontrar o slide ativo usando a classe
                 const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
                 const activeVideo = videos[realIndex];

                                if (activeVideo && activeSlide && activeSlide.classList.contains('swiper-slide-active')) {
                   // Carregar o vídeo se ainda não foi carregado
                   if (activeVideo.dataset.src && !activeVideo.src) {
                     activeVideo.src = activeVideo.dataset.src;
                   }

                   // Autoplay do vídeo ativo
                   if (activeVideo.paused) {
                     activeVideo.play().catch(error => {
                       // Autoplay prevented
                     });
                   }
                 }

               // Atualizar controles de volume
               volumeControls.forEach((control, index) => {
                 if (index === realIndex) {
                   control.style.display = 'flex';
                   // Inicializar com ícone de mudo (X) já que vídeos começam mudos
                   const video = videos[index];
                   if (video && video.muted) {
                     control.style.background = 'rgba(0, 0, 0, 0.1)';
                     control.innerHTML = `
                       <svg viewBox="0 0 24 24">
                         <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>
                         <line x1="1" y1="23" x2="23" y2="1" stroke="currentColor" stroke-width="2"/>
                       </svg>
                     `;
                   }
                 } else {
                   control.style.display = 'none';
                 }
               });
             }
      
                   // Controles de volume
             volumeControls.forEach((control, index) => {
               control.addEventListener('click', function() {
                 const video = videos[index];
                 if (!video) return;

          if (video.muted) {
            video.muted = false;
                   control.style.background = 'rgba(0, 0, 0, 0.3)';
                   // Mostrar ícone de volume
                   control.innerHTML = `
                     <svg viewBox="0 0 24 24">
                       <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>
                     </svg>
                   `;
          } else {
            video.muted = true;
                   control.style.background = 'rgba(0, 0, 0, 0.1)';
                   // Mostrar ícone de mudo com X
                   control.innerHTML = `
                     <svg viewBox="0 0 24 24">
                       <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>
                       <line x1="1" y1="23" x2="23" y2="1" stroke="currentColor" stroke-width="2"/>
                     </svg>
                   `;
                 }
               });
             });
      
      
      
      
           } catch (error) {
             // Erro ao inicializar
           }
  }
  
  // Suporte para eventos do Shopify
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('[data-js-video-carousel]')) {
      setTimeout(() => {
        const newVideoCarousel = event.target.querySelector('[data-js-video-carousel]');
        if (newVideoCarousel) {
          initializeVideoCarousel();
        }
      }, 100);
    }
  });
});
